import { createSlice } from '@reduxjs/toolkit'
export interface modelState {
    tabIndex: number;
}

const initialState: modelState = {
    tabIndex: 0
}

export const Slice = createSlice({
    name: 'favouriteDashboardSearch',
    initialState,
    reducers: {
        CurrentTabIndexSet: (state, action) => {
            const { tabIndex } = action.payload;
            state.tabIndex = tabIndex;
        }
    },
})

// Action creators are generated for each case reducer function
export const { CurrentTabIndexSet } = Slice.actions

export default Slice.reducer